import React, { useEffect } from "react";
import { Button } from "@material-ui/core";
import { useForm, ValidationError } from "@formspree/react";
import { makeStyles } from "@material-ui/core";
import LocationOnIcon from "@material-ui/icons/LocationOn";
import PhoneIcon from "@material-ui/icons/Phone";
import EmailIcon from "@material-ui/icons/Email";
import FacebookIcon from "@material-ui/icons/Facebook";
import InstagramIcon from "@material-ui/icons/Instagram";
import GitHubIcon from "@material-ui/icons/GitHub";
import LinkedInIcon from "@material-ui/icons/LinkedIn";
import { socialMediaLinks } from "./projectdata";
import { motion, useAnimation } from "framer-motion";
import { useInView } from "react-intersection-observer";
const useStyles = makeStyles((theme) => ({
    Contact_me: {
        margin: "50px 0 80px 0 ",
    },
    formWrap: {
        display: "flex",
        justifyContent: "space-between",
        marginTop: "5px",
        [theme.breakpoints.down("sm")]: {
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
        },
        [theme.breakpoints.down("xs")]: {
            alignItems: "inherit",
        },
    },
    form: {
        width: "650px",
        marginTop: "10px",
        marginLeft: "20px",
        [theme.breakpoints.down("md")]: {
            marginLeft: "0px",
            width: "450px",
        },
        [theme.breakpoints.down("sm")]: {
            width: "500px",
        },
        [theme.breakpoints.down("xs")]: {
            justifyContent: "start",
            width: "auto",
        },
    },
    inputFeild: {
        display: "block",
        width: "400px",
        padding: "10px",
        marginTop: "20px",
        border: "none",
        outline: "none",
        transition: "0.3s ease",
        backgroundColor: "transparent",
        borderBottom: "2px solid #709c9e",
        opacity: "0.8",

        "&::placeholder": {
            color: "grey",
        },
        [theme.breakpoints.down("md")]: {
            width: "80%",
        },
        [theme.breakpoints.down("sm")]: {
            width: "80%",
        },
    },
    textarea: {
        display: "block",
        border: "none",
        outline: "none",

        backgroundColor: "transparent",
        border: "2px solid #99b9ba",
        width: "500px",
        height: "120px",
        resize: "none",
        padding: "10px 8px",
        margin: "30px  0 ",
        "&::placeholder": {
            color: "grey",
        },
        [theme.breakpoints.down("md")]: {
            width: "360px",
        },
        [theme.breakpoints.down("sm")]: {
            width: "330px",
        },
        [theme.breakpoints.down("sm")]: {
            width: "90%",
        },
    },
    icon: {
        fontSize: "17px",
        color: "teal",
        marginRight: "10px",
    },
    socialIcon: {
        fontSize: "22px",
        marginRight: "10px",
        color: "teal",
    },
    personalDetails: {
        width: "320px",
        display: "flex",
        flexDirection: "column",
        margin: "0 10%",

        [theme.breakpoints.down("md")]: {
            margin: " 0",
        },
        [theme.breakpoints.down("sm")]: {
            flexDirection: "row",
            width: "100%",
            marginTop: "40px",
            justifyContent: "space-around",
        },
        [theme.breakpoints.down("xs")]: {
            flexDirection: "column",
        },
    },
    social: {
        marginTop: "15px",
        width: "100px",
        cursor: "pointer",
        display: "flex",
        alignItems: "center",
    },
    connect: {
        [theme.breakpoints.down("sm")]: {
            width: "auto",
        },
    },
    socialLinks: {
        textDecoration: "none",
        color: "black",
    },
    submit: {
        width: "130px",
        fontSize: "13px",
        outline: "none",
        color: "white",
        backgroundColor: "#05a7b0",
        "&:hover": {
            backgroundColor: "teal",
        },
    },
    linkwrap: {
        marginBottom: "15px",
        display: "flex",
        alignItems: "center",
    },
}));
function Contact_me() {
    const classes = useStyles();
    const [state, handleSubmit] = useForm("mzbygqkq");
    const { ref, inView } = useInView(); //inview is boolean to say if it is view... ref is to be specified to component that needs to be monitored

    const animation = useAnimation();
    useEffect(() => {
        if (inView) {
            animation.start({
                opacity: 1,
                transition: {
                    duration: 0.6,
                },
            });
        }
        if (!inView) {
            animation.start({
                opacity: 0,
            });
        }
    }, [inView]);

    return (
        <motion.div
            className={classes.Contact_me}
            id="contact_me"
            ref={ref}
            animate={animation}
        >
            <h2 style={{ marginBottom: "10px", marginTop: "0" }}>
                {" "}
                Contact Me
            </h2>
            Feel free to reach out to me through whatever medium you find is
            easiest. I'm happy to answer questions, collaborate, or chat.
            However, if you have other request or question, don’t hesitate to
            use the form.
            <div className={classes.formWrap}>
                <div className={classes.form}>
                    {!state.succeeded ? (
                        <form onSubmit={handleSubmit}>
                            <input
                                id="name"
                                type="text"
                                name="name"
                                placeholder="Full Name*"
                                required
                                className={classes.inputFeild}
                            />
                            <input
                                id="email"
                                type="email"
                                name="email"
                                placeholder="Email*"
                                required
                                className={classes.inputFeild}
                            />
                            <input
                                id="phone_number"
                                type="number"
                                name="phone"
                                placeholder="Phone Number"
                                className={classes.inputFeild}
                            />

                            <textarea
                                id="message"
                                name="message"
                                placeholder="Your Message/Feedback* "
                                className={classes.textarea}
                                required
                            />

                            <Button
                                variant="contained"
                                type="submit"
                                disabled={state.submitting}
                                className={classes.submit}
                            >
                                Submit
                            </Button>
                        </form>
                    ) : (
                        <p>Thanks for your Message! </p>
                    )}
                </div>
                <div className={classes.personalDetails}>
                    <div>
                        <h4>Anjan Poudel</h4>

                        <div className={classes.linkwrap}>
                            <EmailIcon className={classes.icon} />{" "}
                            <div>
                                <a
                                    style={{ color: "teal", cursor: "pointer" }}
                                    href="mailto: poudelanjan8@gmail.com"
                                    target="_blank"
                                >
                                    poudelanjan8@gmail.com
                                </a>{" "}
                            </div>
                        </div>
                        <div className={classes.linkwrap}>
                            <LocationOnIcon className={classes.icon} />
                            <div>Tokha-8,Kathmandu,Nepal</div>{" "}
                        </div>
                        <div className={classes.linkwrap}>
                            <PhoneIcon className={classes.icon} />{" "}
                            <div>(+977)9840162738</div>
                        </div>
                    </div>
                    <div className={classes.connect}>
                        <h2 style={{ textAlign: "center" }}>Social Links</h2>

                        <a
                            href={socialMediaLinks.facebook}
                            target="_blank"
                            className={classes.socialLinks}
                        >
                            <div className={classes.social}>
                                <FacebookIcon className={classes.icon} />{" "}
                                Facebook
                            </div>
                        </a>

                        <a
                            href={socialMediaLinks.instagram}
                            target="_blank"
                            className={classes.socialLinks}
                        >
                            <div className={classes.social}>
                                <InstagramIcon className={classes.icon} />{" "}
                                Instagram
                            </div>
                        </a>

                        <a
                            href={socialMediaLinks.github}
                            target="_blank"
                            className={classes.socialLinks}
                        >
                            <div className={classes.social}>
                                <GitHubIcon className={classes.icon} /> Github
                            </div>
                        </a>

                        <a
                            href={socialMediaLinks.linkedin}
                            target="_blank"
                            className={classes.socialLinks}
                        >
                            <div className={classes.social}>
                                <LinkedInIcon className={classes.icon} />{" "}
                                LinkedIn
                            </div>
                        </a>
                    </div>
                </div>
            </div>
        </motion.div>
    );
}

export default Contact_me;
